import { render, staticRenderFns } from "./EmailSignatures.vue?vue&type=template&id=026a88f4&"
import script from "./EmailSignatures.vue?vue&type=script&lang=js&"
export * from "./EmailSignatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports